import { SagaIterator } from 'redux-saga';
import { fork, takeEvery, takeLatest } from 'redux-saga/effects';

import { handleCreateFlowSubscription } from '~src/flow/sagas/CreateFlowSubscriptionSaga';
import { handleScheduleLinkedTask,handleScheduleSingleFlowTask } from '~src/flow/sagas/ScheduleFlowTaskSagas';
import { handleGeocodeDatasourceAction } from '~src/geocoding/sagas/handleGeocodeDatasourceAction';
import { handleEditPredictiveModel } from '~src/predictiveModel/sagas/EditPredictiveModelSaga';
import { handleEnterPredictiveModelSubspace } from '~src/predictiveModel/sagas/EnterPredictiveModelSpaceSaga';

import {
  AddFieldToSortOrder,
  ContentCountsRequest,
  CreateFlowSubscription,
  DeleteFlowDraft,
  Download,
  EditFlow,
  EditPredictiveModel,
  EditView,
  EncryptContent,
  EnterContentSpaceAction,
  EnterFlowSubspace,
  EnterPredictiveModelSubspace,
  ExtractContent,
  GeocodeDatasource,
  GetContentDetail,
  LaunchRevisionHistory,
  MoveContents,
  NewFlowForDatasource,
  NewPredictiveModelForDatasource,
  RenameContent,
  RunFlow,
  ScheduleLinkedTask,
  ScheduleSingleFlowTask,
  SelectSortOrder,
  ShareContent,
  SortContent,
  WhoHasSeenThisView,
} from '../../../bootstrap/redux/actions/AppActionTypes';
import { processEncryptContentAction } from '../../../extractTask/sagas/EncryptContentSaga';
import { processExtractContentAction } from '../../../extractTask/sagas/ExtractContentSaga';
import { rootFavoritesSaga } from '../../../favorites/sagas/FavoritesSagas';
import { handleDeleteFlowDraft } from '../../../flow/sagas/DeleteFlowDraftSaga';
import { handleEditFlow } from '../../../flow/sagas/EditFlowSaga';
import { handleEnterFlowSubspace } from '../../../flow/sagas/EnterFlowSpaceSaga';
import { handleNewFlowForDatasourceAction } from '../../../flow/sagas/NewFlowForDatasourceSagas';
import { handleRunFlow } from '../../../flow/sagas/RunFlowSaga';
import { rootHomeSaga } from '../../../home/sagas/HomeSaga';
import { handleNewPredictiveModelForDatasourceAction } from '../../../predictiveModel/sagas/NewPredictiveModelForDatasourceSagas';
import { rootHiddenRecsSaga } from '../../../recommendations/sagas/HideRecommendationSagas';
import { handleRevisionHistoryAction } from '../../../revisionHistory/sagas/RevisionHistorySaga';
import { handleShareContentAction } from '../../../sharing/sagas/ShareContentSaga';
import { rootSubscriptionSagas } from '../../../subscription/sagas/SubscriptionSagas';
import { handleEditViewAction } from '../../../views/sagas/EditViewSaga';
import { handleContentCountsRequest } from './ContentCountsSagas';
import { processGetContentDetailAction } from './ContentDetailSagas';
import { processDownload } from './download/DownloadSagas';
import { handleEnterContentSpace } from './EnterContentSpaceSaga';
import { rootMixedContentSaga } from './MixedContentSagas';
import { handleMoveContentAction } from './MoveContentSaga';
import { handleRenameContent } from './RenameContentSagas';
import { processAddFieldToSortOrder, processSelectSortOrder, processSortContent } from './SortContentSagas';
import { handleWhoHasSeenThisViewAction } from './WhoHasSeenThisViewSagas';

export function* rootContentSaga(): SagaIterator {
  yield takeEvery(Download, processDownload);
  yield takeEvery(MoveContents, handleMoveContentAction);
  yield takeEvery(RenameContent, handleRenameContent);
  yield takeEvery(NewFlowForDatasource, handleNewFlowForDatasourceAction);
  yield takeEvery(NewPredictiveModelForDatasource, handleNewPredictiveModelForDatasourceAction);
  yield takeEvery(RunFlow, handleRunFlow);
  yield takeEvery(EditFlow, handleEditFlow);
  yield takeEvery(EditPredictiveModel, handleEditPredictiveModel);
  yield takeEvery(ScheduleSingleFlowTask, handleScheduleSingleFlowTask);
  yield takeEvery(ScheduleLinkedTask, handleScheduleLinkedTask);
  yield takeEvery(CreateFlowSubscription, handleCreateFlowSubscription);
  yield takeEvery(DeleteFlowDraft, handleDeleteFlowDraft);
  yield takeLatest(EnterFlowSubspace, handleEnterFlowSubspace);
  yield takeLatest(EnterPredictiveModelSubspace, handleEnterPredictiveModelSubspace);
  yield takeLatest(SelectSortOrder, processSelectSortOrder);
  yield takeLatest(SortContent, processSortContent);
  yield takeLatest(AddFieldToSortOrder, processAddFieldToSortOrder);
  yield takeLatest(ContentCountsRequest, handleContentCountsRequest);
  yield takeEvery(LaunchRevisionHistory, handleRevisionHistoryAction);
  yield takeEvery(GetContentDetail, processGetContentDetailAction);
  yield takeLatest(WhoHasSeenThisView, handleWhoHasSeenThisViewAction);
  yield takeLatest(EditView, handleEditViewAction);
  yield takeLatest(ShareContent, handleShareContentAction);
  yield takeEvery(EncryptContent, processEncryptContentAction);
  yield takeEvery(ExtractContent, processExtractContentAction);
  yield takeEvery(GeocodeDatasource, handleGeocodeDatasourceAction);
  yield fork(rootMixedContentSaga);
  yield fork(rootFavoritesSaga);
  yield fork(rootHiddenRecsSaga);
  yield fork(rootSubscriptionSagas);
  yield fork(rootHomeSaga);
  yield takeEvery(EnterContentSpaceAction, handleEnterContentSpace);
}
